import React from "react";
import { FaFacebookSquare } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa6";

const Footer = () => {
  return (
    <div className="w-full">
    <div className="flex flex-col items-center justify-center p-4 text-lg bg-[#d1dce4] font-semibold sm:flex-row gap-6">
      <div className="p-4 w-full max-w-[400px] flex-grow text-center border-black border-b-[1px] sm:border-b-[0px]">
        <h1 className="text-xl">Nosotros</h1>
        <p>
          En DISOMEX, creamos soluciones digitales innovadoras con enfoque en
          diseño y desarrollo a medida, superando expectativas con excelencia
          técnica y creatividad.
        </p>
      </div>
  
      <div className="p-4 w-full max-w-[400px] flex-grow text-center border-b-[1px] border-black sm:border-b-[0px]">
        <h1 className="text-xl">Redes</h1>
        <div className="flex justify-center gap-2">
          <FaWhatsapp className="mt-1" />
          <a href="https://wa.me/3325893731" target="_blank">
          <p>3325893731</p></a>
        </div>
        <div className="flex justify-center gap-2">
          <MdEmail className="mt-[6px]" />
          <a href="mailto:contacto@disomex.com.mx"><p>Contacto@disomex.com.mx</p></a>
        </div>
        <div className="flex justify-center gap-2">
          <FaFacebookSquare className="mt-1" />
          <a target="blank" href="https://www.facebook.com/people/Disomex/61557321603770/">
            <p>Facebook</p>
          </a>
        </div>
      </div>
  
      <div className="w-full max-w-[400px] flex-grow text-center">
        <h1>Tecnologías</h1>
        <div className="flex justify-center gap-4">
          <div>
            <p>Java</p>
            <p>Kotlin</p>
            <p>Xcode</p>
            <p>Node js</p>
          </div>
          <div>
            <p>JS</p>
            <p>PHP</p>
            <p>React</p>
            <p>HTML</p>
          </div>
        </div>
      </div>
    </div>
  
    <div className="bg-[#1a354b] p-2 px-4 text-white text-center">
      <p>DISOMEX ©2025 Derechos reservados.</p>
    </div>
  </div>
  
  );
};

export default Footer; 